module.exports = __webpack_public_path__ + "static/img/ymt.39e627f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ymt.png
// module id = IVD7
// module chunks = 1